@if (message().role === 'user') {
  <div class="flex justify-end mb-5">
    @if (userMessage(); as userMessage) {
      <div class="flex lg:max-w-[82%] flex-col items-end">
        <app-ai-ui-context-box class="-mb-3 w-full" [context]="userMessage.context" />
        <div
          class="relative z-10 w-full bg-background-container-primary rounded-radius-primary px-3 py-2 text-sm text-foreground-primary-100 whitespace-pre-wrap break-words"
        >
          {{ userMessage.context?.promptPresetName || userMessage.message }}
        </div>
        @if (message().timestamp; as timestamp) {
          <app-site-date-time class="mt-2 text-xs text-foreground-primary-60" [value]="timestamp" />
        }
      </div>
    }
  </div>
} @else {
  <div class="mb-5 flex flex-col gap-1 lg:max-w-[85%]">
    @for (part of message().parts; track part.id; let firstPart = $first) {
      <div class="flex items-start gap-4">
        @if (showLeadingIcon() && firstPart) {
          <svg-icon key="ai-52" size="32" class="shrink-0 text-action-secondary" />
        } @else {
          <div class="shrink-0 w-8 h-8" aria-hidden="true"></div>
        }
        <div class="grow min-w-0 bg-background-container-primary-50 rounded-radius-primary p-4 text-sm text-foreground-primary-100">
          @switch (part.kind) {
            @case ('output') {
              <app-ai-output-part [part]="$any(part)" />
            }
            @case ('thinking') {
              <app-ai-thinking-part [part]="$any(part)" />
            }
            @case ('tool-call') {
              <app-ai-tool-call-part [part]="$any(part)" />
            }
            @case ('error') {
              <div
                class="text-status-error-text text-sm rounded-radius-secondary bg-status-error-30 border border-status-error-text/30 px-3 py-2"
              >
                {{ $any(part).message }}
              </div>
            }
          }
        </div>
      </div>
    }
    @if (message().timestamp; as timestamp) {
      <app-site-date-time class="mt-1 self-end text-xs text-foreground-primary-60" [value]="timestamp" />
    }
  </div>
}
